import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Check, ChevronLeft, ChevronRight, Loader2, NotebookPen } from "lucide-react";
import { addVisit, errText, fetchPlan } from "@/lib/bf";

const today = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Bucharest" });
const shift = (iso, n) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + n); return d.toLocaleDateString("sv-SE"); };

const Planned = ({ x, day, onDone }) => {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const save = () => {
    if (note.trim().length < 2) return toast.error("Scrie observațiile de la vizită");
    setBusy(true);
    addVisit(x.id, { date: day, note: note.trim(), via: "ruta" }).then(() => { toast.success(`Observații salvate în fișa ${x.salon}`); onDone(); window.dispatchEvent(new Event("bf-plan-changed")); })
      .catch((e) => toast.error(errText(e, "Nu am putut salva"))).finally(() => setBusy(false));
  };
  return (
    <li className="bf-rn-item" data-testid={`bf-rn-planned-${x.id}`}>
      <div className="bf-rn-top"><Link to={`/client/${x.id}`} data-testid={`bf-rn-link-${x.id}`}><b>{x.time ? `${x.time} · ` : ""}{x.salon}</b></Link><span>{[x.city, x.address].filter(Boolean).join(" · ")}</span></div>
      {x.note && <small className="bf-rn-plan-note">Plan: {x.note}</small>}
      <textarea rows={2} value={note} maxLength={2000} onChange={(e) => setNote(e.target.value)} placeholder="Ce s-a discutat, ce a comandat, ce urmează" data-testid={`bf-rn-note-${x.id}`} />
      <button type="button" className="st-btn st-btn--silver" onClick={save} disabled={busy} data-testid={`bf-rn-save-${x.id}`}>{busy ? <Loader2 size={14} className="animate-spin" /> : <Check size={14} />} Salvează în fișă</button>
    </li>
  );
};

export default function BFRouteNotes() {
  const [day, setDay] = useState(today);
  const [d, setD] = useState(null);
  const load = useCallback(() => fetchPlan(day, 1).then((r) => setD(r.days[0])).catch(() => { toast.error("Nu am putut încărca ruta"); setD({ planned: [], visited: [] }); }), [day]);
  useEffect(() => { setD(null); load(); }, [load]);
  return (
    <section className="invite-box bf-rn" data-testid="bf-route-notes">
      <h3><NotebookPen size={18} /> Observații din rută</h3>
      <p className="st-hint">Scrie aici ce ai discutat la fiecare salon din ruta zilei. Observația se salvează automat în fișa clientului, ca vizită notată.</p>
      <div className="bf-plan-nav">
        <button type="button" className="st-btn st-btn--ghost" onClick={() => setDay(shift(day, -1))} data-testid="bf-rn-prev"><ChevronLeft size={16} /></button>
        <b data-testid="bf-rn-day">{new Date(`${day}T12:00:00`).toLocaleDateString("ro-RO", { weekday: "long", day: "numeric", month: "long" })}</b>
        <button type="button" className="st-btn st-btn--ghost" onClick={() => setDay(shift(day, 1))} disabled={day >= today()} data-testid="bf-rn-next"><ChevronRight size={16} /></button>
      </div>
      {!d ? <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă…</p> : (
        <ul className="bf-rn-list">
          {d.planned.map((x) => <Planned key={x.item || x.id} x={x} day={day} onDone={load} />)}
          {d.visited.map((x, i) => (
            <li key={`v${x.id}${i}`} className="bf-rn-item is-done" data-testid={`bf-rn-visited-${x.id}`}>
              <div className="bf-rn-top"><Link to={`/client/${x.id}`}><b><Check size={13} /> {x.salon}</b></Link><span>{x.via === "ruta" ? "notat din rută · salvat în fișă" : "notat în fișă"}</span></div>
              <p>{x.note || "Vizită notată fără observații"}</p>
            </li>
          ))}
          {!d.planned.length && !d.visited.length && <li className="st-hint" data-testid="bf-rn-empty">Nicio vizită în ruta acestei zile. Programează din calendar sau din fișa clientului.</li>}
        </ul>
      )}
    </section>
  );
}
